import  {useState} from 'react'
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// import HeaderSolution from './component/HeaderSolution';
import { Routes, Route, NavLink } from "react-router-dom";
// import { createBrowserHistory } from 'history';
//import Menu from './component/Menu';
import Home from './pages/Home';
import Solution from './pages/Solution';
import OurSolution from './pages/OurSolution';
import Knowledge from './pages/Knowledge';
import Service from './pages/Service';
import Contact from './pages/Contact';
import About from './pages/About';
import Managementconsulting from './pages/Managementconsulting';
import Financialadvisory from './pages/Financialadvisory';
import Dataanalyst from './pages/Dataanalyst';
import Career from './pages/Career';
import { Helmet } from 'react-helmet';
//import JobOpening from './component/Jobopeningheader';
import Jobopening from './pages/Jobopening';
import Job2 from './pages/Job2';
// import Insight from './component/Insight';
import Single from './pages/Single';
import Terms from './pages/Terms';
import Privacypolicy from './pages/Privacypolicy';
import CaseStudy1 from './pages/CaseStudy1';
import CaseStudy2 from './pages/CaseStudy2';
import CaseStudy3 from './pages/CaseStudy3';
import CaseStudy4 from './pages/CaseStudy4';
import CaseStudy5 from './pages/CaseStudy5';
import CaseStudy6 from './pages/CaseStudy6';
import CaseStudy7 from './pages/CaseStudy7';
import CaseStudy8 from './pages/CaseStudy8';
import CaseStudy9 from './pages/CaseStudy9';
import CaseStudy10 from './pages/CaseStudy10';
import CaseStudy11 from './pages/CaseStudy11';
import CaseStudy12 from './pages/CaseStudy12';

import Page404 from './pages/Page404';

import CookieConsent from "react-cookie-consent";
import { Container } from 'react-bootstrap';
import CaseStudy13 from './pages/CaseStudy13';
import CaseStudy14 from './pages/CaseStudy14';
import CaseStudy15 from './pages/CaseStudy15';
import CaseStudy16 from './pages/CaseStudy16';
import CaseStudy17 from './pages/CaseStudy17';
import CaseStudy18 from './pages/CaseStudy18';
import CaseStudy19 from './pages/CaseStudy19';
import CaseStudy20 from './pages/CaseStudy20';
import CaseStudy21 from './pages/CaseStudy21';
import CaseStudy22 from './pages/CaseStudy22';
import CaseStudy23 from './pages/CaseStudy23';
import CaseStudy24 from './pages/CaseStudy24';
import CaseStudy25 from './pages/CaseStudy25';
import CaseStudy26 from './pages/CaseStudy26';
import CaseStudy27 from './pages/CaseStudy27';
import CaseStudy28 from './pages/CaseStudy28';
import CaseStudy29 from './pages/CaseStudy29';
import CaseStudy30 from './pages/CaseStudy30';
import CaseStudy31 from './pages/CaseStudy31';
import CaseStudy32 from './pages/CaseStudy32';
import CaseStudy33 from './pages/CaseStudy33';
import CaseStudy34 from './pages/CaseStudy34';
import CaseStudy35 from './pages/CaseStudy35';
import CaseStudy36 from './pages/CaseStudy36';
import CaseStudy37 from './pages/CaseStudy37';
import CaseStudy38 from './pages/CaseStudy38';
import CaseStudy39 from './pages/CaseStudy39';
import CaseStudy40 from './pages/CaseStudy40';
import CaseStudy41 from './pages/CaseStudy41';
import CaseStudy42 from './pages/CaseStudy42';
import CaseStudy43 from './pages/CaseStudy43';
import CaseStudy44 from './pages/CaseStudy44';
import CaseStudy45 from './pages/CaseStudy45';
import CaseStudy46 from './pages/CaseStudy46';
import CaseStudy47 from './pages/CaseStudy47';

import CaseStudy48 from './pages/CaseStudy48';
import CaseStudy49 from './pages/CaseStudy49';
import CaseStudy50 from './pages/CaseStudy50';
import CaseStudy51 from './pages/CaseStudy51';
import CaseStudy52 from './pages/CaseStudy52';
import CaseStudy53 from './pages/CaseStudy53';
import CaseStudy54 from './pages/CaseStudy54';
import CaseStudy55 from './pages/CaseStudy55';




import CfoServices from './pages/CfoServices';
import InvestmentAdvisoryService from './pages/InvestmentAdvisoryService copy';
import ManagementConsultingService from './pages/ManagementConsultingService copy';
import AIDataService from './pages/AIDataService';
import TechAndAi from './pages/TechAndAi';
import { useScrollToHash } from './component/useScrollToHash';



// import Insight from './component/Insight';

// import Header from './component/Header';
// import Footer from "./component/Footer";
// import { Getintouch } from './component/Getintouch';
// import { Whyus } from './component/Whyus';
// import { Weserve } from './component/Weserve';
// import { ArrowSection } from './component/ArrowSection';

function App() {

  // const history = createBrowserHistory({
  //   //basename: "/staging/preferred-square"
  //   basename: "/"
  // });

 const [blank, setBlank] = useState(false);
  let creat_url = (str) => {
  str = str.split(/\s+/).join("-");
  str = str.toLowerCase();
  str = "/knowledge/" + str;
  return str;
 }

//  const CaseStudyurl1 = creat_url('Expediting the Investment Process Through a Structured Roadmap');
//  const CaseStudyurl2 = creat_url('Enabling A US-Based Hedge Fund To Optimize Its Investment Strategy');
//  const CaseStudyurl3 = creat_url('Streamlining Business And Facilitating The Implementation Of An ERP System');
//  const CaseStudyurl4 = creat_url('Enabling A Real Estate Conglomerate To Secure US 40 Mn Funding to Develop A Logistics Park');
//  const CaseStudyurl5 = creat_url('Strategic Investment Blueprint For A Global Pharma Player');
//  const CaseStudyurl6 = creat_url('Cultivating Employee Engagement Insights & Interventions for a Leading Conglomerate');
//  const CaseStudyurl7 = creat_url('Corporate Strategy For a Real Estate Development Company');
//  const CaseStudyurl8 = creat_url('Strategic Consulting for a PropTech Real Estate Equity Crowdfunding Platform in KSA');
//  const CaseStudyurl9 = creat_url('Industry Research for an HNI Launching a New Coffee Roastery Brand in the U.S');
//  const CaseStudyurl10 = creat_url('Vendor & Counter Party Due Diligence For A Government-Backed KSA Entity');
//  const CaseStudyurl11 = creat_url('Private Equity Valuation Model for an Investment Firm');
//  const CaseStudyurl12 = creat_url('Investment Policy Statement for an Endowment Fund');
//  const CaseStudyurl13 = creat_url('Equity Valuation & Fairness Opinion Exercise For A US-Based Hedge Fund');
//  const CaseStudyurl14 = creat_url('Human Resource Reporting Dashboard For A Company In The Hospitality Industry');
//  const CaseStudyurl15 = creat_url('Funding Strategy For A Real Estate Development Subsidiary');
//  const CaseStudyurl16 = creat_url('Enterprise Project Management Office For A Real Estate Development Company');
//  const CaseStudyurl17 = creat_url('Consolidated Financial Model  for a KSA-Based Real Estate Development Project');
//  const CaseStudyurl18 = creat_url('Investment Memorandum for an Investment Firm');
//  const CaseStudyurl19 = creat_url('Optimizing Business Processes For A Real Estate Developer');
//  const CaseStudyurl20 = creat_url('Financial Due Diligence For A U.S.-Based Private Equity Firm');
//  const CaseStudyurl21 = creat_url('Corporate Strategy For A Single-Family Office');
//  const CaseStudyurl22 = creat_url('Customized BI Dashboards for an Investment Corporate');
//  const CaseStudyurl23 = creat_url('Periodic Portfolio Performance Review For a US-based PE firm');
//  const CaseStudyurl24 = creat_url('Financial Due Dilligence For a London-based Boutique Private Equity Firm');
  


const CaseStudyurl1 = creat_url('Expediting the Investment Process Through a Structured Roadmap');
const CaseStudyurl2 = creat_url('Enabling A U.S.Based Hedge Fund To Optimize Its Investment Strategy');
const CaseStudyurl3 = creat_url('Streamlining Business And Facilitating The Implementation Of An ERP System');
const CaseStudyurl4 = creat_url('Enabling A Real Estate Conglomerate To Secure $40 billion Funding to Develop A Logistics Park');
const CaseStudyurl5 = creat_url('Strategic Investment Blueprint For A Global Pharma Player');
const CaseStudyurl6 = creat_url('Cultivating Employee Engagement Insights & Interventions for a Leading Conglomerate');
const CaseStudyurl7 = creat_url('Corporate Strategy For a Real Estate Development Company');
const CaseStudyurl8 = creat_url('Strategic Consulting for a PropTech Real Estate Equity Crowdfunding Platform in Kingdom of Saudi Arabia');
const CaseStudyurl9 = creat_url('Industry Research for an HNI Launching a New Coffee Roastery Brand in the U.S');
const CaseStudyurl10 = creat_url('Vendor & Counter Party Due Diligence For A Government-Backed Kingdom of Saudi Arabia Entity');
const CaseStudyurl11 = creat_url('Private Equity Valuation Model for an Investment Firm');
const CaseStudyurl12 = creat_url('Investment Policy Statement for an Endowment Fund');
const CaseStudyurl13 = creat_url('Equity Valuation & Fairness Opinion Exercise For A U.S.Based Hedge Fund');
const CaseStudyurl14 = creat_url('Human Resource Reporting Dashboard For A Company In The Hospitality Industry');
const CaseStudyurl15 = creat_url('Funding Strategy For A Real Estate Development Subsidiary');     
const CaseStudyurl16 = creat_url('Enterprise Project Management Office For A Real Estate Development Company');
const CaseStudyurl17= creat_url('Consolidated Financial Model  for a Kingdom of Saudi Arabia-Based Real Estate Development Project');
const CaseStudyurl18= creat_url('Investment Memorandum for an Investment Firm');
const CaseStudyurl19= creat_url('Optimizing Business Processes For A Real Estate Developer');
const CaseStudyurl20 = creat_url('Financial Due Diligence For A U.S.Based Private Equity Firm');
// const CaseStudyurl20 = creat_url('Enabling Sector Understanding Through WACC Benchmarking');
const CaseStudyurl21 = creat_url('Corporate Strategy For A Single-Family Office');
const CaseStudyurl22 = creat_url('Customized BI Dashboards for an Investment Corporate');
const CaseStudyurl23 = creat_url('Periodic Portfolio Performance Review For a U.S.based PE firm');
// const CaseStudyurl24 = creat_url('Financial Due Dilligence For a London-based Boutique Private Equity Firm');
const CaseStudyurl24 = creat_url('Enabling Sector Understanding Through WACC Benchmarking');
const CaseStudyurl25 = creat_url('Tourism Industry Research For a company operating in the hospitality sector');
const CaseStudyurl26 = creat_url('Feasibility Study For A Hotel Development By A Real Estate Development Company');
const CaseStudyurl27 = creat_url('Annual Operating Plan and Budget for a Single Family Office');
const CaseStudyurl28 = creat_url('Comprehensive Business Plan and a go-to-market strategy for a fintech company');
const CaseStudyurl29 = creat_url('Optimizing the Development Stage-Gate Process for a Real Estate company');
const CaseStudyurl30 = creat_url('REIT Market research for a KSA-based real estate fund manager');
const CaseStudyurl31 = creat_url('Public Equity Screening And Industry Benchmarking for a Saudi based family office');
const CaseStudyurl32 = creat_url('Joint Venture Proposal for a Infrastructure-Focused Investment fund');
const CaseStudyurl33 = creat_url('Facilitated IPO planning through comprehensive market analysis and advisor benchmarking');
const CaseStudyurl34 = creat_url('Master Developer Partnership Proposal for a Master Developer based out of KSA');
const CaseStudyurl35 = creat_url('Company Valuation for a Middle East Based Real Estate Investment & Development Firm');
const CaseStudyurl36 = creat_url('Financial Due Diligence for a GP-led secondaries sale');
const CaseStudyurl37 = creat_url('Brand Landscaping for a Destination Development Client');
const CaseStudyurl38 = creat_url('Quarterly reporting framework for a US private equity');
const CaseStudyurl39 = creat_url('Financial Model & Deal Analysis for a Regional Investment Leader in Real Estate');
const CaseStudyurl40 = creat_url('Preliminary Deal Assessment for a private equity firm focused on multi-family real estate');
const CaseStudyurl41 = creat_url('Thematic Research & Acquisition Mapping for a family office with diversified investments');
const CaseStudyurl42 = creat_url('Subsequent Closing Deck for a multi-strategy private equity fund');
const CaseStudyurl43 = creat_url('Standard Operating Procedures Finance & Accounting SOP Framework for an ultra-luxury hospitality group');
const CaseStudyurl44 = creat_url('Fundraising support Portfolio-level Retention Analysis for a technology-focused PE firm');
const CaseStudyurl45 = creat_url('Enterprise Risk Management Comprehensive ERM framework for a family office');
const CaseStudyurl46 = creat_url('Business Requirements Document (BRD) Development');
const CaseStudyurl47 = creat_url('Annual Performance Reporting Framework');
const CaseStudyurl48 = creat_url('Due Diligence & Commercial Evaluation'); 
const CaseStudyurl49 = creat_url('Business Due Diligence'); 
const CaseStudyurl50 = creat_url('Preliminary Due Diligence & Deal Model');
const CaseStudyurl51 = creat_url('Reporting Automation');
const CaseStudyurl52 = creat_url('HR Document Automation Platform');
const CaseStudyurl53 = creat_url('Development Of An Integrated Hospitality Investment Model');
const CaseStudyurl54 = creat_url('Development Of An Institutional-Grade Financial Reporting Template');
const CaseStudyurl55 = creat_url('Cap Table Reconstruction And Exit Returns Waterfall');



const post_status = 'draft'; //'publish'; // draft
 useScrollToHash();
 return (
    <>
    <Helmet>
      <title>AI-Powered Consulting, Advisory & Intelligence | Preferred Square</title>
      <meta name='description' content='Preferred Square delivers AI, data analytics, consulting, investment advisory, and CFO services to corporates, asset managers and investors'/>
      <meta name='keywords' content=''/>
      <script type="application/ld+json">
      {`{
          "@context": "https://schema.org/", 
          "@type": "BreadcrumbList", 
          "itemListElement": [{
            "@type": "ListItem", 
            "position": 1, 
            "name": "Preferred Square | Every Decision Better Informed",
            "item": "https://preferredsquare.com/"  
          },{
            "@type": "ListItem", 
            "position": 2, 
            "name": "About",
            "item": "https://preferredsquare.com/about"  
          },{
            "@type": "ListItem", 
            "position": 3, 
            "name": "Careers",
            "item": "https://preferredsquare.com/careers"  
          },{
            "@type": "ListItem", 
            "position": 4, 
            "name": "Knowledge",
            "item": "https://preferredsquare.com/knowledge"  
          },{
            "@type": "ListItem", 
            "position": 5, 
            "name": "Services",
            "item": "https://preferredsquare.com/service"  
          },{
            "@type": "ListItem", 
            "position": 6, 
            "name": "Contact Us",
            "item": "https://preferredsquare.com/contact"  
          }]
        }`}
        </script>
    </Helmet>
    <div className="App">
{/* <Menu /> */}
{/* <BrowserRouter basename='/' history={history}> */}

    {(blank) ? <div className='blank'> </div> : ""}
      <Routes>
        <Route exact path="/" element={<Home setBlank={setBlank} />} >
          </Route>
          <Route exact path="about" element={<About setBlank={setBlank} />} />
          <Route exact path="solution" element={<Solution setBlank={setBlank} />} />
          <Route exact path="OurSolution" element={<OurSolution setBlank={setBlank} />} />
          <Route exact path="service" element={<Service setBlank={setBlank} />} />
          <Route exact path="knowledge" element={<Knowledge post_status={post_status} setBlank={setBlank} />} />
          <Route exact path="careers" element={<Career setBlank={setBlank} />} />
          <Route exact path="contact" element={<Contact setBlank={setBlank} />} />
          <Route exact path="cfoservices" element={<CfoServices setBlank={setBlank} />} />
          <Route exact path="managementconsulting" element={<Managementconsulting setBlank={setBlank} />} />
          <Route exact path="investmentadvisory" element={<Financialadvisory setBlank={setBlank} />} />
          <Route exact path="dataanalytics" element={<Dataanalyst setBlank={setBlank} />} />        
          <Route exact path="jobopening" element={<Jobopening setBlank={setBlank} />} />    
          <Route exact path="techandai" element={<TechAndAi setBlank={setBlank} />} />    
          

          {/* services */}
          <Route exact path="cfoServices" element={<CfoServices setBlank={setBlank} />} />    
          <Route exact path="investmentadvisoryservice" element={<InvestmentAdvisoryService setBlank={setBlank} />} />    
          <Route exact path="managementconsultingservices" element={<ManagementConsultingService setBlank={setBlank} />} />    
          <Route exact path="aidataService" element={<AIDataService setBlank={setBlank} />} />    


          <Route exact path="termsandconditions" element={<Terms setBlank={setBlank} />} />    
          <Route exact path="privacypolicy" element={<Privacypolicy setBlank={setBlank} />} />    
          <Route exact path={CaseStudyurl1} element={<CaseStudy1 setBlank={setBlank} />} />    
          <Route exact path={CaseStudyurl2} element={<CaseStudy2 setBlank={setBlank} />} />    
          <Route exact path={CaseStudyurl3} element={<CaseStudy3 setBlank={setBlank} />} />    
          <Route exact path={CaseStudyurl4} element={<CaseStudy4 setBlank={setBlank} />} />    
          <Route exact path={CaseStudyurl5} element={<CaseStudy5 setBlank={setBlank} />} />    
          <Route exact path={CaseStudyurl6} element={<CaseStudy6 setBlank={setBlank} />} />    
          <Route exact path={CaseStudyurl7} element={<CaseStudy7 setBlank={setBlank} />} /> 
          <Route exact path={CaseStudyurl8} element={<CaseStudy8 setBlank={setBlank} />} />       
          <Route exact path={CaseStudyurl9} element={<CaseStudy9 setBlank={setBlank} />} />       
          <Route exact path={CaseStudyurl10} element={<CaseStudy10 setBlank={setBlank} />} />      
          <Route exact path={CaseStudyurl11} element={<CaseStudy11 setBlank={setBlank} />} />      
          <Route exact path={CaseStudyurl12} element={<CaseStudy12 setBlank={setBlank} />} />      
          <Route exact path={CaseStudyurl13} element={<CaseStudy13 setBlank={setBlank} />} />  
          <Route exact path={CaseStudyurl14} element={<CaseStudy14 setBlank={setBlank} />} />                
          <Route exact path={CaseStudyurl15} element={<CaseStudy15 setBlank={setBlank} />} />   
          <Route exact path={CaseStudyurl16} element={<CaseStudy16 setBlank={setBlank} />} />   
          <Route exact path={CaseStudyurl17} element={<CaseStudy17 setBlank={setBlank} />} />   
          <Route exact path={CaseStudyurl18} element={<CaseStudy18 setBlank={setBlank} />} />   
          <Route exact path={CaseStudyurl19} element={<CaseStudy19 setBlank={setBlank} />} />  
          <Route exact path={CaseStudyurl20} element={<CaseStudy20 setBlank={setBlank} />} />  
          <Route exact path={CaseStudyurl21} element={<CaseStudy21 setBlank={setBlank} />} />  
          <Route exact path={CaseStudyurl22} element={<CaseStudy22 setBlank={setBlank} />} />  
          <Route exact path={CaseStudyurl23} element={<CaseStudy23 setBlank={setBlank} />} />  
          <Route exact path={CaseStudyurl24} element={<CaseStudy24 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl25} element={<CaseStudy25 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl26} element={<CaseStudy26 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl27} element={<CaseStudy27 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl28} element={<CaseStudy28 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl29} element={<CaseStudy29 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl30} element={<CaseStudy30 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl31} element={<CaseStudy31 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl32} element={<CaseStudy32 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl33} element={<CaseStudy33 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl34} element={<CaseStudy34 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl35} element={<CaseStudy35 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl36} element={<CaseStudy36 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl37} element={<CaseStudy37 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl38} element={<CaseStudy38 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl39} element={<CaseStudy39 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl40} element={<CaseStudy40 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl41} element={<CaseStudy41 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl42} element={<CaseStudy42 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl43} element={<CaseStudy43 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl44} element={<CaseStudy44 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl45} element={<CaseStudy45 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl46} element={<CaseStudy46 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl47} element={<CaseStudy47 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl48} element={<CaseStudy48 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl49} element={<CaseStudy49 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl50} element={<CaseStudy50 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl51} element={<CaseStudy51 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl52} element={<CaseStudy52 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl53} element={<CaseStudy53 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl54} element={<CaseStudy54 setBlank={setBlank} />} />
          <Route exact path={CaseStudyurl55} element={<CaseStudy55 setBlank={setBlank} />} />              

          <Route exact path="casestudy1" element={<CaseStudy1 setBlank={setBlank} />} />    
          <Route exact path="casestudy2" element={<CaseStudy2 setBlank={setBlank} />} />    
          <Route exact path="casestudy3" element={<CaseStudy3 setBlank={setBlank} />} />    
          <Route exact path="casestudy4" element={<CaseStudy4 setBlank={setBlank} />} />    
          <Route exact path="casestudy5" element={<CaseStudy5 setBlank={setBlank} />} />    
          <Route exact path="casestudy6" element={<CaseStudy6 setBlank={setBlank} />} />    
          <Route exact path="casestudy7" element={<CaseStudy7 setBlank={setBlank} />} />    
          <Route exact path="casestudy8" element={<CaseStudy8 setBlank={setBlank} />} />    
          <Route exact path="casestudy9" element={<CaseStudy9 setBlank={setBlank} />} /> 
          <Route exact path="single/:id/:title" element={ <Single post_status={post_status} setBlank={setBlank} />}  /> 
          <Route exact path="businessanalyst" element={<Jobopening setBlank={setBlank} />} />    
          <Route exact path="dataanalyst" element={<Job2 setBlank={setBlank} />} />    
          
          
          <Route exact path="*" element={ <Page404 setBlank={setBlank} />}  /> 
        
            
      </Routes>
    {/* </BrowserRouter> */}

      {/* <HeaderSolution /> */}
      {/* <Header />
      <ArrowSection />
      <Weserve />
      <Whyus />
      <Getintouch />
      <Footer /> */}
    
       <CookieConsent
          debug={false}
          location="bottom"
          flipButtons
          rcc-confirm-button="cookie-btn-wrapper"
          // buttonClasses="cookie-btn-wrapper"
          buttonText="Accept All Cookies"
          enableDeclineButton={true}
          buttonClasses="my-button-class"
          declineButtonText="Decline cookies"
          customButtonWrapperAttributes='<div className"cookie-btn-wrapper"></div>'
          cookieName="CookieConsent"
          declineButtonStyle={{
            color: "#D8D6F6",
            textAlign: "center",
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: "Helvetica",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "30px",
            background:"none",
            textDecorationLine: "underline"
          }}
          style={{ background: "#0A142F",padding:"25px",fontSize:"20px", }}
          buttonStyle={{ color: "#FFFFFF",
            fontSize: "18px",
            fontFamily: "Helvetica",
            border: "1px solid #FFF",
            padding:"15px 20px",
            background: "linear-gradient(180deg, #01C6B2 0%, #048D7F 98.44%)",
            boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.25)" 
          }}
          expires={1000}
        >
         <Container>By clicking “Accept All Cookies”, you agree to the storing of cookies on your device to enhance site
         navigation, analysis of site usage, and assist in our marketing efforts. Go to our <NavLink style={{color:"#03AD9C"}} to="/privacypolicy">privacy policy</NavLink> to know more
         about them 
         </Container>        
    </CookieConsent>
    </div>
    </>
  );
}

export default App;
